import React from 'react';
import '../template-file-css/document-file-template.css';


export const NWBH_ClientSafetyPlan = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='NWBH_ClientSafetyPlan' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>Northwest Behavioral Health Services, Inc.</h3></p>

                <p className='w-750'><h4>Client Safety Plan</h4></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Step 1: Warning signs (thoughts, images, mood, situation, behavior) that a crisis may be developing:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>1.
                        </td>
                        <td className='w-730'>
                            <input type='text' id='txtWarning' name='txtWarning' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>2.
                        </td>
                        <td className='w-730'>
                            <input type='text' id='txtWarning1' name='txtWarning1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>3.
                        </td>
                        <td className='w-730'>
                            <input type='text' id='txtWarning2' name='txtWarning2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Step 2: Internal coping strategies - Things I can do to take my mind off my problems without contacting
                                another person (relaxation technique, physical activity):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>1.
                        </td>
                        <td className='w-730'>
                            <input type='text' id='txtInternal' name='txtInternal' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>2.
                        </td>
                        <td className='w-730'>
                            <input type='text' id='txtInternal1' name='txtInternal1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>3.
                        </td>
                        <td className='w-730'>
                            <input type='text' id='txtInternal2' name='txtInternal2' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h4>Step 3: People and social settings that provide distraction:</h4></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>1. Name</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtAssessorName' name='txtAssessorName' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtPhone' name='txtPhone' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>2. Name</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtAssessorName1' name='txtAssessorName1' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtPhone1' name='txtPhone1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>3. Place</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>4. Place</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPlace' name='txtPlace' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtPlace1' name='txtPlace1' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h4>Step 4: People whom I can ask for help:</h4></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>1. Name</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtAssessorName3' name='txtAssessorName3' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtPhone3' name='txtPhone3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>2. Name</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtAssessorName4' name='txtAssessorName4' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtPhone4' name='txtPhone4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>3. Name</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtAssessorName5' name='txtAssessorName5' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtPhone5' name='txtPhone5' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h4>Step 5: Professionals or agencies I can contact during a crisis:</h4></p>
                
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>1. Clinician Name</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Phone</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Clinician Pager or Emergency Contact #</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtClinician' name='txtClinician' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtHCodePhone' name='txtHCodePhone' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtClinicianPager' name='txtClinicianPager' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>2. Clinician Name</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Phone</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Clinician Pager or Emergency Contact #</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtClinician1' name='txtClinician1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtHCodePhone1' name='txtHCodePhone1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtClinicianPager1' name='txtClinicianPager1' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>3. Local Urgent Care Services</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Urgent Care Services Address</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Urgent Care Services Phone</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtLocalUrgent' name='txtLocalUrgent' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtLocalUrgentAddress' name='txtLocalUrgentAddress' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtLocalUrgentPhone' name='txtLocalUrgentPhone' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>4. Suicide Prevention Lifeline Phone:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtLocalUrgent1' name='txtLocalUrgent1' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Step 6: What helps me during a crisis (what approach/de-escalation techniques should first responders use?)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>1.
                        </td>
                        <td className='w-730'>
                            <input type='text' id='txtApproach' name='txtApproach' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>2.
                        </td>
                        <td className='w-730'>
                            <input type='text' id='txtApproach1' name='txtApproach1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Step 7: Making the environment safe:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>1.
                        </td>
                        <td className='w-730'>
                            <input type='text' id='txtApproach2' name='txtApproach2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>2.
                        </td>
                        <td className='w-730'>
                            <input type='text' id='txtApproach3' name='txtApproach3' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>The one thing that is most important to me and worth living for is:</span>
                    <textarea id='txtParentSpace' name='txtParentSpace' className='add-only'></textarea>
                </p>

            </div>
        </form>

    )
}

